import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Video = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 12.091a.067.067 0 0 0-.005.027v20.59c0 .025.01.042.021.054.006.006.012.01.016.012s.01.003.02.003h26.357c.004 0 .017-.001.031-.016a.048.048 0 0 0 .011-.015V12.118a.068.068 0 0 0-.004-.027.046.046 0 0 0-.025-.024.07.07 0 0 0-.027-.005H2.151a.069.069 0 0 0-.027.005.046.046 0 0 0-.024.024Zm-2.1.027C0 10.926.958 9.97 2.151 9.97h26.344c1.193 0 2.151.956 2.151 2.148v20.593c.02 1.195-.967 2.159-2.137 2.159H2.151A2.155 2.155 0 0 1 0 32.708v-20.59ZM43.5 10.99c.311.19.5.527.5.89v21.065a1.046 1.046 0 0 1-1.521.933l-9.261-4.687a1.045 1.045 0 1 1 .947-1.867l7.74 3.918V13.584l-7.74 3.917a1.045 1.045 0 1 1-.947-1.866l9.26-4.687a1.048 1.048 0 0 1 1.023.041Z"
  }));
});
Video.displayName = 'Video';
Video.defaultProps = {
  'aria-label': 'Video'
};
export default Video;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Video.js
// module id = 3948
// module chunks = 11